<template lang="pug">
  div
    v-radio-group(v-model='isSameDayScheduling' mandatory)
      v-radio(:value="true" color="info500")
        template(v-slot:label)
          .s2.textColorDefault--text {{ $t('only_within_same_day') }}
      v-radio(:value="false" color="info500")
        template(v-slot:label)
          .s2.textColorDefault--text {{ $t('one_day_or_more') }}
  
    .notSameDay(v-if="!isSameDayScheduling")
      .p2.textColorDefault--text {{ $t('customers_can_schedule') }}
      div.d-flex.align-center.mt-2
        v-select.p1(v-model="settings.scheduling_begin_time_value" outlined dense background-color="basic200" placeholder="0" hide-details :items="beginTimeValues" item-text="name" item-value="value")
          template(v-slot:append)
            eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        v-select.mx-3.p1(v-model="settings.scheduling_begin_time_unit" outlined dense background-color="basic200" placeholder="days" hide-details :items="beginTimeUnits" item-text="name" item-value="value")
          template(v-slot:append)
            eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        div.p2.basic700--text(style="min-width: 70px;") {{ $t('in_advance') }}
</template>

<script>
export default {
  name: 'Scheduling',
  components: { },
  props: ['parentSettings'],
  data: () => ({
    beginTimeValues: [
      { name: '1', value: 1 },
      { name: '2', value: 2 },
      { name: '3', value: 3 },
      { name: '4', value: 4 },
      { name: '5', value: 5 },
      { name: '6', value: 6 }
    ],
    beginTimeUnits: [
      { name: 'Days', value: 'days' },
      { name: 'Weeks', value: 'weeks' },
      { name: 'Months', value: 'months' },
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
    }
  }),
  computed: {
    settings: {
      get () {
        return this.parentSettings
      },
      set (newValue) {
        this.$emit('update:parentSettings', newValue)
      }
    },
    isSameDayScheduling: {
      get () {
        if (this.settings) {
          return (this.settings.scheduling_begin_time_value == 0 && this.settings.scheduling_begin_time_unit == 'days')
        }
        return false
      },
      set (newValue) {
        if (newValue) {
          this.settings.scheduling_begin_time_value = 0
          this.settings.scheduling_begin_time_unit = 'days'
        } else {
          this.settings.scheduling_begin_time_value = 1
          this.settings.scheduling_begin_time_unit = 'days'
        }
      }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "only_within_same_day": "Only within the same day",
    "one_day_or_more": "One day or more",
    "customers_can_schedule": "Customers can schedule their orders",
    "in_advance": "in advance"
  },
  "id": {
    "only_within_same_day": "Hanya pada hari yang sama",
    "one_day_or_more": "Satu hari atau lebih ",
    "customers_can_schedule": "Pelanggan dapat menjadwalkan pesanan mereka",
    "in_advance": "sebelumnya"
  }
}
</i18n>
